const BLOCKED_PROPS = new Set<string>([
  'm',
  'margin',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'marginX',
  'marginY',
  'p',
  'padding',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'paddingX',
  'paddingY',
  'color',
  'bg',
  'backgroundColor',
  'opacity',
  'width',
  'height',
  'minWidth',
  'minHeight',
  'maxWidth',
  'maxHeight',
  'size',
  'display',
  'verticalAlign',
  'overflow',
  'overflowX',
  'overflowY',
  'alignItems',
  'alignContent',
  'justifyItems',
  'justifyContent',
  'flexWrap',
  'flexDirection',
  'flex',
  'flexGrow',
  'flexShrink',
  'flexBasis',
  'justifySelf',
  'alignSelf',
  'order',
  'gap',
  'border',
  'borderWidth',
  'borderStyle',
  'borderColor',
  'borderRadius',
  'borderTop',
  'borderRight',
  'borderBottom',
  'borderLeft',
  'borderX',
  'borderY',
  'position',
  'zIndex',
  'top',
  'right',
  'bottom',
  'left',
  'boxShadow',
  'textShadow',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'lineHeight',
  'letterSpacing',
  'textAlign',
  'fontStyle',
  'variant',
  'isActive',
  'isOpen',
  'isSelected',
  'isDisabled',
  'active',
  'selected',
  'fullWidth',
]);

const shouldForwardProp = (propName: string): boolean =>
  !propName.startsWith('$') && !BLOCKED_PROPS.has(propName);

export default shouldForwardProp;
